@if (isRouterStateReady()) {
  <router-outlet></router-outlet>
}

<app-loading-indicator [detectRouteTransitions]="true"></app-loading-indicator>
